// extracted by mini-css-extract-plugin
export var grid = "CardSection-module--grid--1lTOl";